import useTrackPageView from './useTrackPageView';
const TrackPageView = () => {
    useTrackPageView();
    return null;
};
export default TrackPageView;
